<template>
  <div>
    <SummaryUserData></SummaryUserData>
  </div>
</template>

<script>
import SummaryUserData from '../components/SummaryUserData.vue';

export default {
  components: {
    SummaryUserData,
  },
};
</script>
